export const formatTitle = (title) => {
  if (!title) return "";

  return title
    .split(/[_ ]+/)
    .map((word) => word[0]?.toUpperCase() + word?.slice(1))
    .join(" ");
};
